import React from 'react';
import TextField from '@mui/material/TextField';

// Компонент для текстовых полей с централизованными стилями
const StyledTextField = ({ label, value, onChange, ...props }) => {
  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      InputLabelProps={{
        style: { color: 'secondary' }, // цвет текста лейбла
      }}
      InputProps={{
        style: { color: '#9d9d9d' }, // цвет текста в поле
        notchedOutline: {
          borderColor: 'white', // цвет рамки
        },
      }}
      sx={{
        paddingBottom: '7px',
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: 'white', // цвет рамки
          },
          '&:hover fieldset': {
            borderColor: 'white', // цвет рамки при наведении
          },
          '&.Mui-focused fieldset': {
            borderColor: 'white', // цвет рамки при фокусе
          },
          '&.Mui-focused .MuiInputBase-input': {
            color: 'white', // цвет текста внутри при фокусе
          },
        },
      }}
      {...props} // передаем остальные пропсы для индивидуальной настройки
    />
  );
};

export default StyledTextField;
